// pp-calc-rendimiento.js — ¿Cuántas Cajas Sella un Rollo? Rendimiento de
// Cinta y Emplaye (/pages/rendimiento-de-cinta-y-emplaye)
//
// Dos herramientas de piso de almacén en una página:
//
//   CINTA — cuánta cinta gasta cada caja según el patrón de sellado y
//   cuántas cajas salen de un rollo. Supuestos visibles en la página:
//     tira base = largo + 10 cm (5 cm de solape por lado)
//     U = 2 tiras base (una arriba, una abajo)
//     H = U + 4 tiras laterales de (ancho + 10 cm)
//
//   EMPLAYE — metros de película por tarima y tarimas por rollo. La fórmula
//   es EXACTAMENTE la de emplayeNecesario en assets/pp-calc-tarima.js
//   (copiada, no re-inventada): si las dos calculadoras divergen, cuentan
//   historias distintas sobre el mismo rollo.
//
// Aritmética pura probada en tests/calc-rendimiento.test.mjs.
(function (root) {
  'use strict';

  var SOLAPE_CM = 10; // 5 cm de solape por lado de la tira

  // ── CINTA ────────────────────────────────────────────────────────────────
  // Entradas: largoCm y anchoCm de la caja, patron ('u'|'h'),
  // metrosRollo (default 91 — el rollo estándar de 100 yardas trae 91.4 m),
  // pedidosMes (opcional).
  function rendimientoCinta(e) {
    if (!e) return null;
    var l = num(e.largoCm), w = num(e.anchoCm);
    var patron = e.patron === 'h' ? 'h' : e.patron === 'u' ? 'u' : null;
    var rollo = num(e.metrosRollo); if (rollo === null) rollo = 91;
    if ([l, w].some(function (v) { return v === null || v <= 0; }) || !patron || rollo <= 0) return null;

    var tiraBaseCm = l + SOLAPE_CM;
    var cmPorCaja = 2 * tiraBaseCm; // U: una tira arriba y una abajo
    if (patron === 'h') cmPorCaja += 4 * (w + SOLAPE_CM); // + las orillas laterales
    var metrosPorCaja = cmPorCaja / 100;

    var r = {
      patron: patron,
      largoCm: l,
      anchoCm: w,
      tiraBaseCm: tiraBaseCm,
      metrosPorCaja: metrosPorCaja,
      cajasPorRollo: Math.floor(rollo / metrosPorCaja),
      metrosRollo: rollo
    };

    var pedidos = num(e.pedidosMes);
    if (pedidos !== null && pedidos > 0 && r.cajasPorRollo > 0) {
      r.rollosMes = Math.ceil(pedidos / r.cajasPorRollo);
    }
    return r;
  }

  // ── EMPLAYE ──────────────────────────────────────────────────────────────
  // COPIA EXACTA de emplayeNecesario en assets/pp-calc-tarima.js — misma
  // regla práctica: pasadas en espiral con traslape del 50% (subir y bajar)
  // + 4 vueltas de arranque/remate en la base. Película aplicada a mano,
  // sin pre-estiro. NO tocar aquí sin tocar allá (y sus tests).
  function emplayeNecesario(e) {
    var tl = n(e.tarimaL), tw = n(e.tarimaW), h = n(e.alturaCarga);
    var anchoFilm = n(e.anchoFilmCm); if (anchoFilm === null) anchoFilm = 45;
    if ([tl, tw, h].some(function (v) { return v === null || v <= 0; }) || anchoFilm <= 0) return null;
    var perimetroM = 2 * (tl + tw) / 100;
    var avance = anchoFilm * 0.5; // 50% de traslape entre vueltas
    var vueltasEspiral = Math.ceil(h / avance) * 2; // subir y bajar
    var vueltas = vueltasEspiral + 4;
    return { metros: perimetroM * vueltas, vueltas: vueltas };
  }

  // Entradas: tarimaL y tarimaW (cm), alturaCarga (cm),
  // metrosRollo (default 243 — rollo manual típico de 800 pies ≈ 243 m),
  // tarimasMes (opcional).
  function rendimientoEmplaye(e) {
    if (!e) return null;
    var em = emplayeNecesario({ tarimaL: e.tarimaL, tarimaW: e.tarimaW, alturaCarga: e.alturaCarga, anchoFilmCm: e.anchoFilmCm });
    if (!em) return null;
    var rollo = num(e.metrosRollo); if (rollo === null) rollo = 243;
    if (rollo <= 0) return null;

    var r = {
      metrosPorTarima: em.metros,
      vueltas: em.vueltas,
      tarimasPorRollo: Math.floor(rollo / em.metros),
      metrosRollo: rollo
    };

    var tarimas = num(e.tarimasMes);
    if (tarimas !== null && tarimas > 0 && r.tarimasPorRollo > 0) {
      r.rollosMes = Math.ceil(tarimas / r.tarimasPorRollo);
    }
    return r;
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }
  var n = num; // alias: la copia de emplayeNecesario usa n() como en tarima

  root.PPCalcRendimiento = {
    SOLAPE_CM: SOLAPE_CM,
    rendimientoCinta: rendimientoCinta,
    emplayeNecesario: emplayeNecesario,
    rendimientoEmplaye: rendimientoEmplaye
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-rendimiento]');
    if (!raiz) return;
    var C = window.PPCalcRendimiento;

    function fmt(n, dec) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: dec === undefined ? 0 : dec });
    }

    // Cada bloque (cinta / emplaye) trae su propio form, su propio resultado
    // y su propio recálculo en vivo — son dos herramientas apiladas.
    function cablear(bloque, calcular, pintar) {
      if (!bloque) return;
      var form = bloque.querySelector('form');
      var out = bloque.querySelector('[data-calc-resultado]');
      if (!form || !out) return;

      function correr() {
        pintar(out, calcular(new FormData(form)));
      }

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        correr();
        out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });

      var timerRecalc = null;
      function recalcEnVivo() {
        if (out.hidden) return;
        clearTimeout(timerRecalc);
        timerRecalc = setTimeout(function () { correr(); }, 350);
      }
      form.addEventListener('input', recalcEnVivo);
      form.addEventListener('change', recalcEnVivo);
      return form;
    }

    // ── Bloque cinta ───────────────────────────────────────────────────────
    cablear(
      raiz.querySelector('[data-calc-bloque="cinta"]'),
      function (f) {
        return C.rendimientoCinta({
          largoCm: f.get('largo'), anchoCm: f.get('ancho'),
          patron: f.get('patron'), metrosRollo: f.get('rollo'),
          pedidosMes: f.get('pedidos')
        });
      },
      function (out, r) {
        out.hidden = false;
        if (!r) {
          out.innerHTML = '<p class="pp-calc__error">Revisa los datos: largo, ancho y metros del rollo deben ser mayores a cero.</p>';
          return;
        }
        var html = '<div class="pp-calc__veredicto pp-calc__veredicto--ok">';
        html += '<p class="pp-calc__veredicto-titulo">Un rollo te sella ' + fmt(r.cajasPorRollo) + ' cajas</p>';
        html += '<p class="pp-calc__veredicto-dato">Cada caja gasta <strong>' + fmt(r.metrosPorCaja, 2) + ' m de cinta</strong> con el patrón ' + (r.patron === 'h' ? 'H' : 'U sencillo') + ', y tu rollo trae ' + fmt(r.metrosRollo, 1) + ' m.</p>';
        if (r.rollosMes) {
          html += '<p class="pp-calc__veredicto-dato">Para tus pedidos del mes necesitas <strong>' + fmt(r.rollosMes) + ' rollo(s)</strong>.</p>';
        }
        html += '</div>';
        html += '<dl class="pp-calc__detalle">';
        html += '<div class="pp-calc__detalle-fila"><dt>Cinta por caja</dt><dd>' + fmt(r.metrosPorCaja, 2) + ' m</dd></div>';
        html += '<div class="pp-calc__detalle-fila"><dt>Tira base (largo + 10 cm de solape)</dt><dd>' + fmt(r.tiraBaseCm) + ' cm</dd></div>';
        html += '</dl>';
        html += '<p class="pp-calc__nota">El cálculo asume tiras bien puestas de un solo jalón. Cinta que se rompe, dispensador desajustado o retrabajos comen rollo — en la práctica cuenta con un 5–10% menos.</p>';
        out.innerHTML = html;
        dibujarCinta(r);
      }
    );

    // La caja con sus tiras de cinta en 3D: la U vs la H se ENTIENDE viendo
    // (motor compartido pp-caja-3d; las tiras son piezas delgadas color 1).
    function dibujarCinta(r) {
      var cont = raiz.querySelector('[data-calc-dibujo-cinta]');
      if (!cont || !window.PPCaja3D || !window.PPCaja3D.montar) return;
      if (!r) { cont.hidden = true; return; }
      cont.hidden = false;
      var L = r.largoCm, A = r.anchoCm;
      var H = Math.max(Math.round(Math.min(L, A) * 0.7), 8); // alto ilustrativo
      var CINTA = 4.8;   // ancho de cinta estándar (cm)
      var G = 0.5;       // grosor visual de la tira
      var piezas = [];
      // La caja (color 0, la de siempre)
      piezas.push({ dims: [L, A, H], pos: [0, 0, 0], color: 0 });
      // Tira U: sobre la tapa a lo largo del centro + bajada en las dos caras cortas
      var zC = (A - CINTA) / 2;
      piezas.push({ dims: [L, CINTA, G], pos: [0, H, zC], color: 1 });
      piezas.push({ dims: [G, CINTA, H * 0.45], pos: [-G, H * 0.55, zC], color: 1 });
      piezas.push({ dims: [G, CINTA, H * 0.45], pos: [L, H * 0.55, zC], color: 1 });
      if (r.patron === 'h') {
        // La H: sella también las orillas de la tapa, a lo ancho
        [0, L - CINTA].forEach(function (x) {
          piezas.push({ dims: [CINTA, A, G], pos: [x, H, 0], color: 1 });
          piezas.push({ dims: [CINTA, G, H * 0.45], pos: [x, H * 0.55, -G], color: 1 });
          piezas.push({ dims: [CINTA, G, H * 0.45], pos: [x, H * 0.55, A], color: 1 });
        });
      }
      window.PPCaja3D.montar(cont, {
        caja: [L + 2, A + 2, H + 2],
        mostrarCaja: false,
        piezas: piezas.map(function (pz) { return { dims: pz.dims, pos: [pz.pos[0] + 1, pz.pos[1], pz.pos[2] + 1], color: pz.color }; }),
        etiqueta: 'Patrón ' + (r.patron === 'h' ? 'H — la U más las orillas selladas' : 'U sencillo — una tira arriba (y abajo)') + ' — arrástralo para girarlo'
      });
    }

    // ── Bloque emplaye ─────────────────────────────────────────────────────
    var bloqueEmplaye = raiz.querySelector('[data-calc-bloque="emplaye"]');
    var formEmplaye = cablear(
      bloqueEmplaye,
      function (f) {
        var dims = dimsTarima(f);
        return C.rendimientoEmplaye({
          tarimaL: dims.l, tarimaW: dims.w,
          alturaCarga: f.get('altura'), metrosRollo: f.get('rollo'),
          tarimasMes: f.get('tarimas')
        });
      },
      function (out, r) {
        out.hidden = false;
        if (!r) {
          out.innerHTML = '<p class="pp-calc__error">Revisa los datos: medidas de tarima, altura de carga y metros del rollo deben ser mayores a cero.</p>';
          return;
        }
        var html = '<div class="pp-calc__veredicto pp-calc__veredicto--ok">';
        html += '<p class="pp-calc__veredicto-titulo">Un rollo te envuelve ' + fmt(r.tarimasPorRollo) + ' tarima(s)</p>';
        html += '<p class="pp-calc__veredicto-dato">Cada tarima gasta <strong>' + fmt(r.metrosPorTarima, 1) + ' m de emplaye</strong> (' + fmt(r.vueltas) + ' vueltas con traslape del 50%), y tu rollo trae ' + fmt(r.metrosRollo) + ' m.</p>';
        if (r.rollosMes) {
          html += '<p class="pp-calc__veredicto-dato">Para tus tarimas del mes necesitas <strong>' + fmt(r.rollosMes) + ' rollo(s)</strong>.</p>';
        }
        html += '</div>';
        html += '<dl class="pp-calc__detalle">';
        html += '<div class="pp-calc__detalle-fila"><dt>Emplaye por tarima</dt><dd>' + fmt(r.metrosPorTarima, 1) + ' m</dd></div>';
        html += '<div class="pp-calc__detalle-fila"><dt>Vueltas (espiral subir y bajar + 4 de base)</dt><dd>' + fmt(r.vueltas) + '</dd></div>';
        html += '</dl>';
        html += '<p class="pp-calc__nota">Regla para película aplicada a mano, sin pre-estiro. Si tu rollo rinde bastante menos, puede que traiga menos metros de los prometidos — compruébalo en el Verificador de Emplaye.</p>';
        out.innerHTML = html;
      }
    );

    // La tarima custom muestra sus dos inputs solo al elegir "otra".
    if (formEmplaye) {
      var selTarima = formEmplaye.querySelector('[name="tarima"]');
      var customWrap = formEmplaye.querySelector('[data-tarima-custom]');
      if (selTarima && customWrap) {
        selTarima.addEventListener('change', function () {
          customWrap.hidden = selTarima.value !== 'custom';
        });
      }
    }

    function dimsTarima(f) {
      var v = f.get('tarima');
      if (v === 'custom') return { l: f.get('tarima_l'), w: f.get('tarima_w') };
      var partes = String(v).split('x'); // "120x100"
      return { l: partes[0], w: partes[1] };
    }
  });
})();
